import {useDispatch, useSelector} from "react-redux"
import {useState} from "react"
import {
	makeNewOneTimeSearch, resetArticleSearchQuery,
	selectArticleSearchQuery,
} from "../../../reducers/articleSearchQuerySlice"
import {Box, FormControl, IconButton, OutlinedInput, Stack, styled, Typography} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import {useWorkspaceContext} from "../../../pages/Dashboard"

const SearchSourceButton = styled( Box, {
	shouldForwardProp: (prop) => prop !== "isSelectedSource", // forward this value as prop, not attr
})(({ theme, isSelectedSource }) => ({
	fontSize: "small",
	color: "grey",
	cursor: "pointer",
	"&:hover": {
		color: theme.palette.primary.main,
	},
	...(isSelectedSource && {
		fontSize: "medium",
		fontWeight: "bold",
		color: theme.palette.primary.main,
	}),
}))

export function SearchPanelNav() {
	const dispatch = useDispatch()
	const { workspaceId } = useWorkspaceContext()
	const [source, setSource] = useState("pubmed")
	const [query, setQuery] = useState("")
	const articlesSearchQuery = useSelector((state) => selectArticleSearchQuery(state, workspaceId))

	const handleSubmit = (e) => {
		e.preventDefault()
		if (articlesSearchQuery?.query && articlesSearchQuery.query !== query) {
			dispatch(resetArticleSearchQuery(workspaceId))
		}
		dispatch(makeNewOneTimeSearch({ query, source, workspaceId }))
	}

	const changeSourceAndSubmit = (source) => {
		setSource(source)
		// unlike the above, we always want to reset the oneTimeSearch state when changing the search source
		dispatch(resetArticleSearchQuery(workspaceId))
		dispatch(makeNewOneTimeSearch({ query, source, workspaceId }))
	}

	const handleChange = (e) => {
		setQuery(e.target.value)
	}

	return (
		<FormControl
			as={"form"}
			fullWidth
			variant="outlined"
			onSubmit={handleSubmit}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					minHeight: "40px"
				}}
			>
				<OutlinedInput
					sx={{ height: "30px", flexGrow: 1 }}
					placeholder={
						source === "pubmed"
							? "Search PubMed once"
							: "Search this workspace once"
					}
					inputProps={{
						style: {
							padding: "0px 8px 0px 8px"
						}
					}}
					value={query}
					onChange={handleChange}
					endAdornment={
						<IconButton aria-label="search articles" type={"submit"} edge="end">
							<SearchIcon />
						</IconButton>
					}
				/>
				<Stack
					sx={{
						alignItems: "flex-start",
						padding: "0px 10px",
						minWidth: "100px",
					}}
				>
					<SearchSourceButton
						onClick={() => changeSourceAndSubmit("pubmed")}
						isSelectedSource={source === "pubmed"}
					>
						PubMed
					</SearchSourceButton>
					<SearchSourceButton
						onClick={() => changeSourceAndSubmit("library")}
						isSelectedSource={source === "library"}
					>
						My Workspace
					</SearchSourceButton>
				</Stack>
			</Box>
			{ articlesSearchQuery.articles.length > 0 &&
				(
					<Typography variant={"subtitle2"}>Viewing {articlesSearchQuery.articles.length} of {articlesSearchQuery.count > articlesSearchQuery.reachable ? `${articlesSearchQuery.reachable}+` : articlesSearchQuery.count} results</Typography>
				)
			}
		</FormControl>
	)
}